import React from 'react';
import { Paper, Grid, Typography } from '@mui/material';
import { INotificationFromStore } from 'shared/models/INotification.interface';
import { completeDateFormat } from 'utilities/formatDate';

export interface INotificationsFromStoreProps {
  notification: INotificationFromStore;
  index: number;
  notificationsAreAllRead: boolean;
}

const NotificationsFromStore = ({
  notification,
  index,
  notificationsAreAllRead,
}: INotificationsFromStoreProps) => (
  <Paper
    sx={{
      p: 2,
      ':hover': {
        boxShadow:
          'var(--ds-shadow-overlay, 0 4px 8px -2px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31))',
      },
      borderColor: (theme) =>
        !notificationsAreAllRead && !notification.isNotificationRead
          ? `${theme.palette.primary.main}`
          : 'none',
    }}
  >
    <Grid
      container
      spacing={1}
      direction='column'
      data-testid={`notification-item-${index}`}
      id={`notification-item-${index}`}
    >
      <Grid item>
        <Typography
          className={
            !notificationsAreAllRead && !notification.isNotificationRead
              ? 'kfic2-bodyTextBold'
              : 'kfic2-bodyText'
          }
          id={`notification-title-${index}`}
        >
          {notification.notificationData.title}
        </Typography>
      </Grid>
      <Grid
        item
        container
        spacing={3}
        sx={{
          justifyContent: !notification.notificationData.subtitle
            ? 'flex-end'
            : 'normal',
        }}
      >
        {notification.notificationData.subtitle && (
          <Grid item flexGrow={1}>
            <Typography
              className='kfic2-bodyTextSmall'
              id={`notification-subtitle-${index}`}
            >
              {notification.notificationData.subtitle}
            </Typography>
          </Grid>
        )}

        <Grid
          item
          flexGrow={1}
          sx={{ justifyContent: 'right', display: 'flex' }}
        >
          <Typography
            className='kfic2-bodyTextSmall'
            sx={{
              color: (theme) => `${theme.palette?.text.disabled} !important`,
            }}
            id={`notification-date-${index}`}
          >
            {completeDateFormat(notification.creationDate)}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  </Paper>
);

export default NotificationsFromStore;
